/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type { TGetCurrentPriceModel, IMappers, TGetCurrentPriceResponse } from './types';
import type { IPublicV1GetCurrentPriceResponseSchema } from '../../entities/responses/PublicV1GetCurrentPriceResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export const defaultConfig: TGetCurrentPriceModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'commercial-geo-analytics',
  pathApi: '/v1/get-current-price/',
  responseType: 'json',
} as TGetCurrentPriceModel;

export function createGetCurrentPriceModel(): TGetCurrentPriceModel {
  return {
    ...defaultConfig,
  };
}

export interface IGetCurrentPriceOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetCurrentPrice<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetCurrentPriceOptions<TResponse200, TResponse400>): Promise<
  TGetCurrentPriceResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetCurrentPriceModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicV1GetCurrentPriceResponseSchema);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetCurrentPriceResponse;
}
